import { SESSION_REFRESH_INTERVAL_MS } from "@ac-expo/utils";
import { useEffect } from "react";

/**
 * Hook to periodically refresh the BetterAuth session cookie cache.
 *
 * BetterAuth's cookie cache has a `refreshCache` option that only triggers
 * when `getSession` is called AND the cookie age has reached the `updateAge` threshold.
 * Since `useSession` only fetches once at mount, we need to periodically call
 * `refetchSession` to trigger the refresh.
 *
 * @param isAuthenticated - Whether the user is currently authenticated
 * @param refetchSession - Function to refetch the session (from useSession hook)
 */
export const useSessionRefresh = (isAuthenticated: boolean, refetchSession: () => void) => {
  useEffect(() => {
    if (!isAuthenticated) return;

    const interval = setInterval(() => {
      refetchSession();
    }, SESSION_REFRESH_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isAuthenticated, refetchSession]);
};
